import type { GuardAppEnvironment } from './types';
import { env as devEnv } from './dev';
import { env as ip4xEnv } from './ip4x';
import { env as ip4cmsStagingEnv } from './ip4cms-staging';
import { env as ip4xStagingEnv } from './ip4x-staging';
import { env as prodEnv } from './prod';

export type { GuardAppEnvironment, GuardAuthMode } from './types';

declare const __APP_MODE__: string;

const ENV_MAP: Record<string, GuardAppEnvironment> = {
  dev: devEnv,
  ip4x: ip4xEnv,
  'ip4cms-staging': ip4cmsStagingEnv,
  'ip4x-staging': ip4xStagingEnv,
  prod: prodEnv,
};

function resolveMode(): string {
  if (typeof __APP_MODE__ !== 'undefined' && __APP_MODE__) return __APP_MODE__;
  if (typeof import.meta !== 'undefined' && import.meta.env?.MODE) return import.meta.env.MODE;
  return 'dev';
}

const mode = resolveMode();
const base = ENV_MAP[mode] ?? devEnv;

const buildApiKey = import.meta.env.VITE_GUARD_API_KEY as string | undefined;
const buildTenantId = import.meta.env.VITE_GUARD_TENANT_ID as string | undefined;

export const env: GuardAppEnvironment = {
  ...base,
  guardApiKey: buildApiKey || base.guardApiKey,
  guardTenantId: buildTenantId || base.guardTenantId,
};
